import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../api";
import { AttendanceLocalService } from "../../../../@types/attendance-local-service";
import { AttendanceLocalServiceResponse } from "../../../../@types/attendance-local-service-response";
import { AxiosError } from "axios";

export type AttendanceLocalServiceUpdateData = Pick<
    AttendanceLocalService,
    | "agendamento"
    | "atendimento"
> & {
    servico: AttendanceLocalService["servico"]["id"];
}

export function useAttendanceLocalServiceUpdate(id: AttendanceLocalService["id"]) {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "service", "update", id],
        mutationFn: async (data: AttendanceLocalServiceUpdateData) => {
            const response = await apisiseci.put<AttendanceLocalServiceResponse>(
                `/cms/servicos_unidades/${id}/`, data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Serviço atualizado com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "service", "list"],
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error.response.data.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
